import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Send, CheckCircle } from 'lucide-react';
import toast from 'react-hot-toast';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email');
      return;
    }
    setSubscribed(true);
    toast.success('Successfully subscribed!');
    setEmail('');
    setTimeout(() => setSubscribed(false), 3000);
  };

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="relative bg-gradient-to-r from-gray-900 to-gray-800 rounded-3xl p-12 md:p-16 overflow-hidden"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
        >
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-primary-500/10 rounded-full -translate-y-1/2 translate-x-1/3" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-secondary-500/10 rounded-full translate-y-1/2 -translate-x-1/3" />

          <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-10">
            <div className="text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary-500/20 rounded-full text-primary-400 text-sm font-medium mb-4">
                <Mail size={16} />
                Newsletter
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Get <span className="text-primary-400">Exclusive Deals</span> & Updates
              </h2>
              <p className="text-gray-400 max-w-md">
                Subscribe to our newsletter and be the first to know about new products, special offers, and seasonal discounts.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="w-full max-w-md">
              <div className="relative">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  className="w-full px-6 py-4 pr-36 rounded-full bg-white/10 border border-white/20 text-white placeholder-gray-400 focus:outline-none focus:border-primary-500 focus:bg-white/15 transition-all"
                  disabled={subscribed}
                />
                <motion.button
                  type="submit"
                  className={`absolute right-2 top-1/2 -translate-y-1/2 px-6 py-2.5 rounded-full font-semibold text-sm flex items-center gap-2 transition-all ${
                    subscribed
                      ? 'bg-green-500 text-white'
                      : 'bg-gradient-to-r from-primary-500 to-secondary-500 text-white hover:shadow-lg'
                  }`}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  disabled={subscribed}
                >
                  {subscribed ? (
                    <>
                      <CheckCircle size={16} /> Subscribed
                    </>
                  ) : (
                    <>
                      Subscribe <Send size={16} />
                    </>
                  )}
                </motion.button>
              </div>
              <p className="text-gray-500 text-xs mt-3 text-center lg:text-left">
                No spam, unsubscribe anytime. Read our privacy policy.
              </p>
            </form>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Newsletter;
